<template>
  <div class="lp-editor">
    <textarea :id="editorId"></textarea>
    <!-- popup -->
    <div v-if="vPopup" style="font-size:13px">
      <div class="help-outside" @click="vPopup=false" v-if="vPopup"></div>
      <div class="help-desc">
        <b>1. 이미지 아래에 텍스트 넣기</b>
        <div class="help-sub-desc">이미지 아래에 빈 공간을 클릭하여 커서가 들어가면 텍스트를 입력합니다.</div>
        <img src="https://s3.ap-northeast-2.amazonaws.com/launchpack-storage/media/admin/editor_tip1.png" style="margin-bottom:12px">
        <b>2. 이미지 위에 텍스트 넣기</b>
        <div class="help-sub-desc">엔터 모양의 버튼을 클릭하여 커서가 들어가면 텍스트를 입력합니다.</div>
        <img src="https://s3.ap-northeast-2.amazonaws.com/launchpack-storage/media/admin/editor_tip2.png">
      </div>
    </div>
  </div>
</template>

<script>
  import suneditor from 'suneditor'
  import plugins from 'suneditor/src/plugins'
  import table from 'suneditor/src/plugins/submenu/table'
  import lang from 'suneditor/src/lang'
  import uuidv4 from 'uuid/v4';
  export default {
    name: "LpEditor",
    mixins: [
    ],
    props: {
      text: {
        type: String
      }
    },
    beforeDestroy() {
      this.editor.destroy();
    },
    mounted() {
      if(this.isLaunchpack) {
        this.image_max_width = 3000;
      }

      this.editorId = uuidv4();
      this.$nextTick(()=>{
        this.editor = suneditor.create(this.editorId, {
          defaultStyle: "font-size: 15px;",
          plugins: plugins,
          buttonList: [
            [ 'font', 'fontSize'], ['fontColor', 'hiliteColor'],
            ['bold', 'italic'], ['underline', 'strike'],
            ['align', 'outdent', 'indent'],
            ['list', 'table' ],
            ['horizontalRule', 'video', 'image', 'link'],
            ['codeView', 'showBlocks', 'preview','fullScreen'],
            ['undo', 'redo']
          ],
          font: [
            "Nanum Gothic",
            "Noto Sans CJK kr",
            "Spoqa Han Sans",
            "BM DoHyeon",
            "BM HANNA",
            "BM YEONSUNG",
            "BM KIRANGHAERANG",
            "BM JUA",
            "BM EULJIRO",
            "Arita Buri Bold",
            "Arita Buri SemiBold",
            "Arita Dotum Medium",
            "Arita Dotum SemiBold",
            "S-CoreDream",
            "Godo",
            "AppleSDGothicNeo"
          ],
          fontSize: [
            8,9,10,11,12,13,14,15,16,17,18,19,20,22,24,26,28,36,48,72
          ],
          lang: lang.ko,
          width: '100%',
          height: 'auto',
          minHeight: '200px',
          maxHeight: this.$store.getters.device === 'pc' ? 'calc(100vh - 150px)' : 'calc(100vh - 300px)',
          stickyToolbar: this.$store.getters.device === 'pc' ? '50px' : '50px'
        });

        this.editor.showController = (res, controllers) => {
          let editable = this.$el.getElementsByClassName('sun-editor')[0];
          let rect = controllers[0].getBoundingClientRect();
          let top = rect.y - editable.getBoundingClientRect().top + rect.height + 80;
          controllers[1].style.top = top + 'px'
        };

        this.$nextTick(()=>{
          let list = document.getElementsByClassName('se-btn-list');
          for(let i=0; i<list.length; i++) {
            let item = list[i];
            let titleKor = {
            'Nanum Gothic': '나눔 고딕',
            'Noto Sans CJK kr': '노토 산스',
            'Spoqa Han Sans': '스포카 한 산스',
            'BM DoHyeon': '배민 도현체',
            'BM HANNA': '배민 한나체',
            'BM YEONSUNG': '배민 연성체',
            'BM KIRANGHAERANG': '배민 기랑해랑체',
            'BM JUA': '배민 주아체',
            'BM EULJIRO': '배민 을지로체',
            'Arita Buri Bold': '아리따 부리 Bold',
            'Arita Buri SemiBold': '아리따 부리 SemiBold',
            'Arita Dotum Medium': '아리따 돋움 Medium',
            'Arita Dotum SemiBold': '아리따 돋움 SemiBold',
            'S-CoreDream': '에스코어 드림',
            'Godo': '고도체',
            'AppleSDGothicNeo': '애플 산들고딕 Neo'
            };
            let title = titleKor[item.title];
            if(title) {
              item.title = title;
              item.innerText = title;
              //item.setAttribute('data-value', title);
            }
          }

          //this.editor.setContents(!this.text ? '' : this.text);
          if(this.text && this.text !== '') {
            this.$el.getElementsByClassName('sun-editor-editable')[0].innerHTML = this.text;
          }

          /*let editor_el = document.getElementById('suneditor_'+this.editorId);
          let wrapper = editor_el.getElementsByClassName('se-wrapper-inner')[0];
          let listeners = wrapper.getEventListeners('keydown');
          for(let i=0; i<listeners.length; i++) {
            let listener = listeners[i].listener;

            if(listener && listener.name === 'onKeyDown_wysiwyg') {
              wrapper.removeEventListener('keydown', listener);
            }
          }*/
          //
          let tray = this.$el.getElementsByClassName('se-btn-tray')[0];
          let alert = document.createElement('div');
          alert.innerHTML = `<div class="unselect"
style="display:flex;align-items:center;color:#ff5722;padding:8px 4px;font-size:13px;">
<i class="material-icons" style="margin-right:4px;font-size:16px">help</i>
이미지 삽입 후 텍스트 입력 방법</div>`;
          alert.addEventListener('click', ()=>{
            this.vPopup = true;
          });
          tray.appendChild(alert);

          let desc = document.createElement('div');
          desc.innerHTML = `<div class="unselect" style="display:flex;align-items:center;padding:8px 4px;font-size:10px;">*각 이미지 용량 최대 5MB, 가로 1000px, 세로 10000px까지 업로드 가능합니다.</div>`;
          tray.appendChild(desc);

        });

        this.editor.onChange = (e) => {
          if(this.text !== e)
            this.emitted = true;
          this.$emit('update:text', e);
        };

        this.editor.onKeyUp = (event) => {
          if(event.key==='Backspace' || event.key==='Delete') {
            let e = this.editor.getContents();
            if(this.text !== e)
              this.emitted = true;
            this.$emit('update:text', e);
          }
        };
        this.editor.onImageUploadBefore = async (files, info, core, uploadHandler) => {
          // console.log('onImageUploadBefore')
          // console.log(files, info, core, uploadHandler)
          let isError = undefined;
          for (let file of files) {
            if(file.size > 1024 * 1024 * 5) {
              // console.log('용량초과')
              this.limit_files.push(file.name)
              isError = 1;
              break;
            } else {
              // console.log('해상도초과')
              let res = await this.resolutionCheck(file);
              if(res) {
                this.limit_files.push(file.name)
                isError = 2;
                break;
              }
            }
          }
          if(isError!==undefined) {
            const imgs = await this.editor.getImagesInfo()
            // console.log('삭제전', imgs, this.limit_files.length)
            setTimeout(()=> {
              if(imgs.length>0 && this.limit_files.length>0) {
                if(isError===1) {
                  this.toastTime(`최대 5MB, 파일까지만 업로드 가능합니다.` +
                    `\n \n ${this.limit_files.join('\n')}`, 10000);
                }
                else if(isError===2) {
                  let size_text = '';
                  if(this.resolutionErrorType==='width') {
                    size_text = `가로 사이즈를 ${this.image_max_width}`
                  } else if(this.resolutionErrorType==='height') {
                    size_text = `세로 사이즈를 ${this.image_max_height}`
                  }
                  this.toastTime(`이미지 해상도 ${size_text} 이하로 조정해주세요.` +
                    `\n \n ${this.limit_files.join('\n')}`, 10000);
                }
                imgs[imgs.length-1].delete();
                this.limit_files = [];
              }
            }, 100)

          }
        }
        // this.editor.onImageUpload = async (targetElement, index, state, info, remainingFilesCount, core) => {}
      });
    },
    data() {
      return {
        editor: undefined,
        editorId: '',
        emitted: false,
        vPopup: false,
        limit_files: [],
        image_max_width: 3000,
        image_max_height: 10000,
        resolutionErrorType: undefined
      }
    },
    watch: {
      text(n) {
        if(!this.emitted){
          this.$el.getElementsByClassName('sun-editor-editable')[0].innerHTML = !n ? '' : n;
        }
        else {
          this.emitted = false;
        }
      }
    },
    methods: {
      // 해상도 체크
      async resolutionCheck(file) {
        let reader = new FileReader();
        await reader.readAsDataURL(file);
        const image = new Image();
        let vm = this;
        await new Promise((resolve, reject) => {
          reader.onload = function(e) {
            image.src = e.target.result;
            resolve(reader.result)
          }
        })

        return await new Promise((resolve, reject) => {
          image.onload = (ie) => {
            const width = ie.target.naturalWidth;
            const height = ie.target.naturalHeight;
            if(width > this.image_max_width) {
              this.resolutionErrorType = 'width'
              resolve(true)
            } else if(height > this.image_max_height) {
              this.resolutionErrorType = 'height'
              resolve(true)
            } else {
              resolve(false);
            }
          };
        })
      }
    }
  }
</script>

<style lang="stylus">
  import 'suneditor/dist/css/suneditor.min.css'
  .sun-editor-editable td p
    margin 0

  .content ul
    margin-left 0 !important

  .content table td
  .content table th
    border-width 1px !important

  .help-outside
    position fixed
    top 0
    left 0
    right 0
    bottom 0
    z-index 120
    background rgba(0,0,0, 0.3)

  .help-desc
    position fixed
    z-index 125
    top 120px
    left 300px
    background-color white
    border-radius 4px
    width 490px
    padding 20px
    font-size 14px
    white-space pre-line

  .help-sub-desc
    color #666666
    margin-top 4px
    margin-bottom 12px
</style>
<style lang="stylus">
  .lp-editor .content p:not(:last-child),
  .lp-editor .content dl:not(:last-child),
  .lp-editor .content ol:not(:last-child),
  .lp-editor .content ul:not(:last-child),
  .lp-editor .content blockquote:not(:last-child),
  .lp-editor .content pre:not(:last-child),
  .lp-editor .content table:not(:last-child)
    margin-bottom 0 !important
  .sun-editor-editable p
    margin 0 !important
</style>
